<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot">
        <small v-if="!gDisableSettingByCenter && schoolName">{{ $t('campus') }}: {{ schoolName }}</small>
      </template>
    </PageHeaderSlot>

    <!-- 課程查詢：課程種類、對象年齡/年級、上課地點、時間表、開班日期
學費收費：學費金額、教材費、繳費方式
報名手續：報名流程、所需資料、學位情況（尚有名額/額滿）
上課安排：請假、補堂、調堂規則及上限
退款轉班：公司退款/轉班條例（如無法處理需可設定轉真人客服）
一般行政：中心地址、交通指南、聯絡電話、電郵、收據/發票查詢
師資教學：導師資歷摘要、惡劣天氣（颱風/黑雨）上課安排
營業時間：每日營業及辦公時間 -->

    <v-form ref="dataForm" @submit.prevent="">
      <v-card class="mb-4">
        <v-card-text class="px-2">

          <!-- <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                label="centerAddress"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row> -->
          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormInput
                :fieldValue.sync="formData.default_center_address"
                label="centerAddress"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :fieldValue.sync="formData.default_working_hour"
                label="workingHour"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :fieldValue.sync="formData.default_transport_guide"
                label="transportGuide"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :fieldValue.sync="formData.default_tutor_info"
                label="tutorInfo"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :fieldValue.sync="formData.default_bad_weather_info"
                label="badWeatherInfo"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :fieldValue.sync="formData.default_refund_info"
                label="refundInfo"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <FormTextarea
                :fieldValue.sync="formData.default_payment_info"
                label="paymentInfoDetail"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4" v-if="canEdit">
        <FormButton @click="save()" />
      </div>
    </v-form>

    <!-- Modal: 接收通知電郵 -->
    <!-- <FormDialog
      v-if="enableMultiNotifyEmail"
      :maxWidth="500"
      title="notifyEmail"
      ref="emailFormDialog"
      formRef="emailForm"
    >
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput type="email" label="email" placeholder="email" :fieldValue.sync="addEmail" required />
        </v-col>
      </v-row>
    </FormDialog> -->

  </v-container>
</template>

<script>
import FormTextarea from '@/components/formField/FormTextarea.vue'
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import Datatable from '@/components/Datatable.vue'
import FormDialog from '@/components/FormDialog.vue'
import FormUploader from '@/components/formField/FormUploader.vue'
// import FormButton from '@/components/layout/FormButton.vue'
// import fields from '../Student/components/fields'

export default {
  name: 'BasicSetting',
  components: {
    FormTextarea,
    FormInput,
    FormSelect,
    Datatable,
    FormDialog,
    FormUploader,
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    initLogo: '',
    formData: {
      logo_list: [],
      custom_text: '',
      phone: '',
      email: '',
      whatsapp_message: '',
      member_terms_field: '',
      whatsapp_number: '',
      month_period: 1,
      admin_notification_email: [],
      payment_terms: '',
      default_center_address: '',
      default_working_hour: '',
      default_transport_guide: '',
      default_tutor_info: '',
      default_bad_weather_info: '',
      default_refund_info: '',
      default_payment_info: '',
    },

    schoolName: '',

    addEmail: '',

    registerForm: {
      tableData: [],
      need_sign: false,
      terms_zh: '',
      terms_en: '',
    },

    lessonPeriodOptions: [
      { value: 1, text: vm.$t('monthPerPeriod', { month: 1 }) },
      { value: 2, text: vm.$t('monthPerPeriod', { month: 2 }) },
      { value: 3, text: vm.$t('monthPerPeriod', { month: 3 }) },
    ],
    registerFormHeaders: [
      { value: 'show', text: '' },
      { value: 'required', text: vm.$t('required'), width: 150 },
    ],
    needOptions: [
      { value: true, text: vm.$t('need') },
      { value: false, text: vm.$t('noNeed') },
    ],
    whatsappConnected: false,
    whatsappQR: "",
  }),
  computed: {
    // permission & setting
    canEdit() {
      // [T46] admin account 只可read
      return !this.isAppMode(['T46']) || this.userType !== 'admin'
    },
  },
  methods: {
    async getSetting() {
      try {
        const data = await this.$Fetcher.GetSetting()
        this.insertData(data)
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('toggleLoadingPage', false)
      }
    },
    insertData(data) {
      for (const key in this.formData) {
        if (this.$validate.DataValid(data[key])) {
          this.formData[key] = data[key]
        }
      }
      this.formData.logo_list = []
      if (data['logo']) {
        this.formData.logo_list.push({ name: data['logo'], file: data['logo'] })
      }
      this.initLogo = data['logo'] || ''
      if (data.admin_notification_email) {
        this.formData.admin_notification_email = data.admin_notification_email.map(el => {
          return {
            id: el,
            email: el,
          }
        })
      }
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (!this.canEdit) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }

      if (!this.gDisableSettingByCenter) {
        const check = await this.gfCheckSchoolSelected()
        if (!check) return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      let payload = {
        logo: this.formData.logo_list.length ? this.formData.logo_list[0].file : '',
        custom_text: this.formData.custom_text,
        default_center_address: this.formData.default_center_address,
        default_working_hour: this.formData.default_working_hour,
        default_transport_guide: this.formData.default_transport_guide,
        default_tutor_info: this.formData.default_tutor_info,
        default_bad_weather_info: this.formData.default_bad_weather_info,
        default_refund_info: this.formData.default_refund_info,
        default_payment_info: this.formData.default_payment_info,
      }

      try {
        await this.$Fetcher.UpdateSetting(payload)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccessInMinutes',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: BasicSetting')
      this.userType = this.gfGetUserType(true)
      this.getSetting()
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep.small-checkbox {
  & label {
    color: var(--v-colorBlack-base);
    font-weight: 500;
    font-size: 0.875rem;
  }
}
::v-deep.title-checkbox {
  & label {
    color: var(--v-colorBlack-base);
    font-weight: 500;
    font-size: 0.875rem;
    width: 250px;
  }
}
</style>
